export const selectSalaryConfigurations = (state) =>
  state.companySalaryConfiguration?.salaryConfigurations || [];
export const selectSalaryConfigurationLoading = (state) =>
  state.companySalaryConfiguration?.loading || false;
export const selectSalaryConfigurationError = (state) =>
  state.companySalaryConfiguration?.error || null;
export const selectSelectedSalaryConfiguration = (state) =>
  state.companySalaryConfiguration?.selectedSalaryConfiguration || null;
export const selectSalaryConfigurationPagination = (state) =>
  state.companySalaryConfiguration?.pagination || {};
export const selectSalaryConfigurationApproving = (state) =>
  state.companySalaryConfiguration?.approving || false;
